import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'
import React from 'react'

import { Error } from './Error'

export const Number: React.FC<
  TextField & { errors: Partial<FieldErrorsImpl>; register: UseFormRegister<FieldValues> }
> = ({ name, defaultValue, errors, label, register, required }) => {
  return (
    <div className="field">
      <label htmlFor={name}>
        {label}
        {required && ' *'}
      </label>
      <input defaultValue={defaultValue} id={name} type="number" {...register(name, { required })} />
      {errors[name] && <Error name={name} />}
    </div>
  )
}
